var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
var RenameComponent = /** @class */ (function (_super) {
    __extends(RenameComponent, _super);
    function RenameComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.importAction = new EventEmitter();
        _this.active = false;
        _this.importing = false;
        return _this;
    }
    RenameComponent.prototype.show = function () {
        this.active = true;
        this.modal.show();
    };
    RenameComponent.prototype.import = function () {
        this.importing = true;
    };
    RenameComponent.prototype.close = function () {
        this.modal.hide();
        this.active = false;
        this.importing = false;
    };
    __decorate([
        ViewChild('rename', { static: false })
    ], RenameComponent.prototype, "modal", void 0);
    __decorate([
        Output()
    ], RenameComponent.prototype, "importAction", void 0);
    RenameComponent = __decorate([
        Component({
            selector: 'rename',
            styles: [".rename-list{ padding: 17px 16px 0; width: 100%; table{ width: 100%; td,th{ padding: 0 8px; line-height: 36px; color: rgba(0, 0, 0, .6); width: 50%; border-bottom: 1px solid #DCDEE3; } th{ background-color: #F2F3F7; } } input[type=\"text\"]{ height: 28px; width: 90%; } } .modal .fe-modal-container .fe-modal-header{ border-bottom: 1px solid #f4f4f4; .fe-modal-header-title{ line-height: 50px; } }"],
            template: "<div bsModal #rename=\"bs-modal\" id=\"rename\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"rename\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\" allow-drag> <div class=\"modal-dialog\"> <div class=\"modal-content  fe-modal-container\"> <form *ngIf=\"active\" #renameForm=\"ngForm\" novalidate (ngSubmit)=\"import()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"modal-title fe-modal-header-title\"> <span>{{lc(\"Rename\")}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"rename-list\"> <table> <tr> <th>{{lc(\"ExistingName\")}}</th> <th>{{lc(\"ImportName\")}}</th> </tr> <tr> <td>January</td> <td><input type=\"text\"></td> </tr> </table> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!renameForm.form.valid||importing\" [buttonBusy]=\"importing\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <!-- <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> --> </div> </div> </form> </div> </div> </div>"
        })
    ], RenameComponent);
    return RenameComponent;
}(ConfigureComponentBase));
export { RenameComponent };
